/**
 * The part editor is available after principal analysis ends, including a
 * failed analysis: staff must still be able to finish the specs for a manual
 * quote or replace the source file.
 */
export const isPartEditorAvailable = ({
    primaryAnalysisFinished,
    analysisTimedOut,
    blocking3dFailure,
}: {
    primaryAnalysisFinished: boolean;
    analysisTimedOut: boolean;
    blocking3dFailure: boolean;
}) => primaryAnalysisFinished || analysisTimedOut || blocking3dFailure;
